import { render } from "./PinReferencePreview.vue?vue&type=template&id=4b13074a&ts=true"
import script from "./PinReferencePreview.vue?vue&type=script&lang=ts"
export * from "./PinReferencePreview.vue?vue&type=script&lang=ts"

const cssModules = {}
import style0 from "./PinReferencePreview.vue?vue&type=style&index=0&id=4b13074a&lang=scss&module=true"
cssModules["$style"] = style0

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__cssModules',cssModules]])

export default __exports__